import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";

const GA_ID = "G-FECFCS6KGH";

// Sends a GA4 page_view on every client-side route change (SPA tracking) and
// records a first-party page view in our own analytics. Auto page_view is
// disabled in the gtag config (send_page_view:false), so no duplicates.
export default function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    const fullPath = location.pathname + location.search;
    // first-party analytics (admin audience dashboard)
    trackPageView(fullPath);
    // Google Analytics 4 — only after explicit consent (Consent Mode)
    if (localStorage.getItem("bh_consent") !== "granted" || typeof window.gtag !== "function") return undefined;
    // small delay so per-page <title>/canonical (set by Seo.jsx) are applied first
    const id = setTimeout(() => {
      window.gtag("event", "page_view", {
        page_path: fullPath,
        page_location: window.location.href,
        page_title: document.title,
        send_to: GA_ID,
      });
    }, 80);
    return () => clearTimeout(id);
  }, [location.pathname, location.search]);

  return null;
}
